import { memo, useEffect } from "react";
import { FaTimesCircle } from "react-icons/fa";
import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from "react-icons/fi";
import { IconType } from "react-icons";

type SnackbarProps = {
  variant: "error" | "success" | "warning" | "info";
  message: string;
  timeout?: number;
  open: boolean;
  close: () => void;
};

type variantsProps = {
  error: IconType;
  success: IconType;
  warning: IconType;
  info: IconType;
};

const variants = {
  error: "bg-red-600 text-white",
  success: "bg-green-600 text-white",
  warning: "bg-yellow-600 text-white",
  info: "bg-teal-600 text-white",
};

const icons: variantsProps = {
  error: FaTimesCircle,
  success: FiCheckCircle,
  warning: FiAlertCircle,
  info: FiInfo,
};

const Snackbar = ({
  variant = "info",
  message,
  timeout,
  open,
  close,
}: SnackbarProps) => {
  useEffect(() => {
    let timer: number;
    if (open) {
      if (timeout) {
        timer = window.setTimeout(() => {
          if (close) {
            close();
          }
        }, timeout * 1000);
      }
    }
    return () => {
      clearTimeout(timer);
    };
  }, [timeout, close, open]);

  const handleClose = () => {
    if (close) {
      close();
    }
  };

  const Icon: IconType = icons[variant];

  return (
    <>
      {open && (
        <div
          className={`fixed bottom-0 left-1/2 -translate-x-1/2 mb-5 py-3 px-4 rounded-md shadow-lg ${variants[variant]}`}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Icon className="mr-3" />
              <span className="text-sm font-bold">{message}</span>
            </div>
            <button
              className="text-white hover:text-gray-100 font-bold ml-1"
              onClick={() => handleClose()}
            >
              <FiX />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(Snackbar);
